import { DialogContentText as MUIDialogContentText } from '@mui/material'

import { DialogContentTextProps } from './dialog-content-text.types'

export const DialogContentText = ({ children, ...props }: DialogContentTextProps) => {
  return <MUIDialogContentText {...props}>{children}</MUIDialogContentText>
}
